export const NavColors = {
	Light: 'light',
	Dark: 'dark',
	Primary: 'primary',
} as const;
